/* bs-alle-maten.js: filteren, sorteren en toevoegen op de pagina "Alle maten".
   Hoort bij sections/bs-alle-maten.liquid. Zonder dit script staat alles er gewoon:
   alle groepen zichtbaar, filterknoppen springen naar de groep, "In winkelwagen" is een formulier.
   Toevoegen loopt via window.BBWinkel (assets/bb-winkelwagen.js). Er wordt hier niet met geld gerekend:
   alle prijzen staan al in de pagina via snippets/bs-prijs, sorteren leest alleen data-attributen.

   Pre-order: de knop op een uitverkochte kaart staat in de Liquid en wordt door bs-preorder.js
   afgehandeld (data-bs-po-open). Hier staat alleen het vangnet: als de voorraad ondertussen op is,
   tonen we de melding van window.BSPreorder in plaats van een kale foutregel.
   Contract: nacht-16-09/pre-order-contract.md. */
(function () {
  'use strict';

  var BRON = 'Alle maten';

  /* Klantteksten uit window.BSTekst (snippets/bs-teksten.liquid, sleutels bs.* in de
     locale-bestanden). Ontbreekt een tekst, dan de Nederlandse terugval die hier
     in de code staat. {naam} in een tekst wordt ingevuld met waarden.naam. */
  function tk(sleutel, terug, waarden) {
    var bron = window.BSTekst;
    var s = (bron && typeof bron[sleutel] === 'string' && bron[sleutel] !== '' && bron[sleutel].indexOf('translation missing') !== 0) ? bron[sleutel] : terug;
    if (!waarden) { return s; }
    return String(s).replace(/\{(\w+)\}/g, function (heel, naam) {
      return Object.prototype.hasOwnProperty.call(waarden, naam) ? String(waarden[naam]) : heel;
    });
  }

  function tekstAantal(n) { return n + ' ' + (n === 1 ? tk('am_product_een', 'product') : tk('am_producten', 'producten')); }

  /* Melding van het pre-orderonderdeel in de kaart zetten (knoppen doet bs-preorder.js zelf). */
  function toonPreorder(melding, html) {
    if (!melding || !html) { return false; }
    melding.removeAttribute('data-soort');
    melding.innerHTML = html;
    return true;
  }

  /* De kaart is gerenderd toen de maat nog leverbaar was. Raakt hij tussendoor uitverkocht,
     dan zou er "Op voorraad" boven een melding staan die het tegenovergestelde zegt. Daarom
     hier hetzelfde beeld als in de Liquid: label "Tijdelijk uitverkocht" en geen koopknop.
     De pre-orderknop staat in de melding zelf. */
  function kaartOpUit(form, knop) {
    var kaart = form && form.closest ? form.closest('[data-bs-am-kaart]') : null;
    if (!kaart || kaart.__bsAmUit) { return; }
    kaart.__bsAmUit = true;
    var stand = kaart.querySelector('.bs-op-voorraad, .bs-am-na');
    if (stand && stand.parentNode) {
      var uit = document.createElement('span');
      uit.className = 'bs-am-uit';
      uit.textContent = tk('uitverkocht', 'Tijdelijk uitverkocht');
      stand.parentNode.replaceChild(uit, stand);
    }
    if (knop) { knop.hidden = true; }
  }

  function initWortel(wortel) {
    if (wortel.__bsAm) { return; }
    wortel.__bsAm = true;

    var chips = Array.prototype.slice.call(wortel.querySelectorAll('[data-bs-am-filter]'));
    var groepen = Array.prototype.slice.call(wortel.querySelectorAll('[data-bs-am-groep]'));
    var aantalEl = wortel.querySelector('[data-bs-am-aantal]');
    var sorteerVeld = wortel.querySelector('[data-bs-am-sorteer-veld]');
    var sorteer = wortel.querySelector('[data-bs-am-sorteer]');

    /* ---------- filter ---------- */
    function filter(waarde, hashBijwerken) {
      var bestaat = waarde === 'alle' || groepen.some(function (g) { return g.getAttribute('data-bs-am-groep') === waarde; });
      if (!bestaat) { waarde = 'alle'; }
      var zichtbaar = 0;
      groepen.forEach(function (g) {
        var aan = waarde === 'alle' || g.getAttribute('data-bs-am-groep') === waarde;
        g.hidden = !aan;
        if (aan) { zichtbaar += g.querySelectorAll('[data-bs-am-kaart]').length; }
      });
      chips.forEach(function (c) {
        var aan = c.getAttribute('data-bs-am-filter') === waarde;
        c.setAttribute('aria-pressed', aan ? 'true' : 'false');
        c.removeAttribute('aria-current');
      });
      if (aantalEl) { aantalEl.textContent = tekstAantal(zichtbaar); }
      if (hashBijwerken && window.history && window.history.replaceState) {
        var hash = waarde === 'alle' ? '' : '#diameter-' + waarde;
        try { window.history.replaceState(null, '', window.location.pathname + window.location.search + hash); } catch (e) { /* geen probleem */ }
      }
    }

    chips.forEach(function (c) {
      c.setAttribute('role', 'button');
      c.addEventListener('click', function (e) {
        e.preventDefault();
        filter(c.getAttribute('data-bs-am-filter'), true);
      });
      c.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); c.click(); }
      });
    });

    var begin = 'alle';
    var m = /^#diameter-(\d+)$/.exec(window.location.hash || '');
    if (m) { begin = m[1]; }
    filter(begin, false);

    /* ---------- sorteren (binnen elke groep; de tipkaart blijft achteraan) ---------- */
    if (sorteer && sorteerVeld) {
      sorteerVeld.hidden = false;
      sorteer.addEventListener('change', function () {
        var sleutel = sorteer.value === 'prijs' ? 'prijs' : (sorteer.value === 'permeter' ? 'permeter' : 'volgorde');
        groepen.forEach(function (g) {
          var raster = g.querySelector('[data-bs-am-raster]');
          if (!raster) { return; }
          var kaarten = Array.prototype.slice.call(raster.querySelectorAll('[data-bs-am-kaart]'));
          kaarten.sort(function (a, b) {
            var d = Number(a.getAttribute('data-' + sleutel)) - Number(b.getAttribute('data-' + sleutel));
            if (d !== 0) { return d; }
            return Number(a.getAttribute('data-volgorde')) - Number(b.getAttribute('data-volgorde'));
          });
          var tip = raster.querySelector('[data-bs-am-tip]');
          kaarten.forEach(function (k) { raster.insertBefore(k, tip || null); });
        });
      });
    }

    /* ---------- in winkelwagen ---------- */
    wortel.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('[data-bs-am-toevoegen]') : null;
      if (!form) { return; }
      var winkel = window.BBWinkel;
      if (!winkel || typeof winkel.pakketToevoegen !== 'function' || !window.fetch) { return; } // gewoon formulier
      e.preventDefault();

      var knop = form.querySelector('button[type="submit"]');
      var knopTekst = form.querySelector('[data-bs-am-knoptekst]');
      var melding = form.querySelector('[data-bs-am-melding]');
      if (!knop || knop.getAttribute('data-status') === 'bezig') { return; }

      var idVeld = form.querySelector('input[name="id"]');
      var id = idVeld ? Number(idVeld.value) : 0;
      if (!id) { form.submit(); return; }
      var naam = form.getAttribute('data-naam') || tk('am_het_artikel', 'Het artikel');
      var po = window.BSPreorder;

      /* Voorcontrole zonder netwerkverzoek: is deze maat sinds het laden uitverkocht
         geraakt, dan meteen de pre-ordermelding in plaats van een verzoek dat 422 geeft. */
      if (po && melding) {
        var vooraf = po.controleer({ variantId: id, gevraagd: 1, inWagen: 0 });
        if (vooraf.soort === 'uit' && toonPreorder(melding, po.meldingHtml('uit', { variantId: id, bron: BRON }))) {
          kaartOpUit(form, knop);
          return;
        }
      }

      clearTimeout(form.__bsAmTimer);
      knop.setAttribute('data-status', 'bezig');
      knop.setAttribute('aria-disabled', 'true');
      if (knopTekst) { knopTekst.textContent = tk('bezig_toevoegen', 'Bezig met toevoegen'); }
      if (melding) { melding.innerHTML = ''; melding.removeAttribute('data-soort'); }

      winkel.pakketToevoegen({ regels: [{ product: { id: id }, aantal: 1 }] }, 'cart-icon-bubble')
        .then(function (uit) {
          winkel.meldWijziging(uit.antwoord);
          knop.setAttribute('data-status', 'klaar');
          if (knopTekst) { knopTekst.textContent = tk('toegevoegd', 'Toegevoegd'); }
          if (melding) {
            melding.textContent = tk('am_in_wagen', '{naam} ligt in je winkelwagen.', { naam: naam }) + ' ';
            var link = document.createElement('a');
            link.href = (winkel.wortel ? winkel.wortel() : '/') + 'cart';
            link.textContent = tk('am_bekijk', 'Bekijk winkelwagen');
            melding.appendChild(link);
          }
        })
        .catch(function (fout) {
          knop.removeAttribute('data-status');
          if (knopTekst) { knopTekst.textContent = tk('in_winkelwagen', 'In winkelwagen'); }
          if (!melding) { return; }
          melding.setAttribute('data-soort', 'fout');
          melding.textContent = (fout && fout.allesOfNiets && fout.uitlegVanShopify)
            ? tk('am_fout_uitleg', 'Toevoegen lukte niet: {uitleg}', { uitleg: fout.uitlegVanShopify })
            : tk('am_fout', 'Toevoegen lukte niet. Controleer je verbinding en probeer het opnieuw.');

          /* Vangnet na een 422 (onderzoek/pre-order.md 4.7): verse winkelwagen lezen, de teller
             in de kop bijwerken en de kale foutregel vervangen door de juiste pre-ordermelding.
             Deze kaart voegt altijd 1 toe, dus 'deels' kan hier niet voorkomen: alleen alles-ligt-
             al-in-de-wagen (M3), net-uitverkocht (M1) of het algemene vangnet (M4). */
          if (!po || !fout || fout.status !== 422 || typeof winkel.winkelwagenLezen !== 'function') { return; }
          return Promise.resolve(typeof po.ververs === 'function' ? po.ververs() : null)
            .catch(function () { return null; })            // verse voorraad is meegenomen, geen eis
            .then(function () { return winkel.winkelwagenLezen(); })
            .then(function (wagen) {
              winkel.meldWijziging(wagen);
              var nu = po.inWagen(wagen, id);
              var u = po.controleer({ variantId: id, gevraagd: 1, inWagen: nu });
              var html = (u.soort === 'vol' || u.soort === 'uit')
                ? po.meldingHtml(u.soort, { variantId: id, bron: BRON })
                : po.meldingHtml('na422', { variantId: id, inWagenNu: nu, bron: BRON });
              toonPreorder(melding, html);
              if (u.soort === 'uit') { kaartOpUit(form, knop); }
            })
            .catch(function () { /* de kale foutregel blijft staan */ });
        })
        .then(function () {
          knop.removeAttribute('aria-disabled');
          if (knop.getAttribute('data-status') === 'klaar') {
            form.__bsAmTimer = setTimeout(function () {
              knop.removeAttribute('data-status');
              if (knopTekst) { knopTekst.textContent = tk('in_winkelwagen', 'In winkelwagen'); }
            }, 2500);
          }
        });
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bs-am]'), initWortel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* thema-editor: sectie opnieuw geladen */
  document.addEventListener('shopify:section:load', start);
})();
